import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73d597fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=73d597fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d597fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d597fa')) {
      api.createRecord('73d597fa', component.options)
    } else {
      api.reload('73d597fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73d597fa&scoped=true", function () {
      api.rerender('73d597fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screen/components/AreaPanel/index.vue"
export default component.exports